import {Stack} from '@mantine/core';
import {PlatformLoader} from "@pac/platform-ui-components";

import {HeadingRow} from "../../credentials/components/HeadingRow.tsx";
import {HandoffEmailForm} from "../forms/HandoffEmailForm.tsx";
import {HandoffSignInForm} from "../forms/HandoffSignInForm.tsx";
import {HandoffMessage} from "../components/HandoffMessage.tsx";
import {MethodSelection} from "../components/MethodSelection.tsx";
import {UseAnotherAccount} from "../components/UseAnotherAccount.tsx";
import {useHandoff} from "../hooks/useHandoff.ts";
import {MODULE_CONFIG} from "../config";

export const IndexPage = () => {

    const {
        state,
        handleEmail,
        handleSignIn,
        handleSelectSso,
        handleSelectPassword,
        handleUseAnotherAccount,
    } = useHandoff();

    if (state.phase === 'error') {
        return <HandoffMessage message={state.message}/>;
    }

    if (state.phase === 'checking' || state.phase === 'federated' || state.phase === 'redirecting') {
        return <PlatformLoader message="Signing you in...Please wait"/>;
    }

    if (state.phase === 'selection') {
        return (
            <Stack gap={'xl'}>
                <HeadingRow title={MODULE_CONFIG.title}/>
                <MethodSelection
                    handleSSOButtonClick={handleSelectSso}
                    handlePasswordClick={state.target.passwordClient ? handleSelectPassword : undefined}
                />
                <UseAnotherAccount onClick={handleUseAnotherAccount}/>
            </Stack>
        );
    }

    return (
        <Stack gap={'xl'}>
            <HeadingRow title={MODULE_CONFIG.title}/>
            {state.signInError && <HandoffMessage message={state.signInError}/>}
            {state.phase === 'email'
                ? (
                    <HandoffEmailForm
                        emailAddress={state.email}
                        handleSubmit={handleEmail}
                    />
                )
                : (
                    <>
                        <HandoffSignInForm
                            key={state.email}
                            emailAddress={state.email}
                            handleSubmit={handleSignIn}
                        />
                        <UseAnotherAccount onClick={handleUseAnotherAccount}/>
                    </>
                )}
        </Stack>
    );
};
